<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <h1>
      {{ $t("sector.create") }}
    </h1>
    <b-row class="mb-3 ml-0">
      <router-link to="././all">
        <b-button size="sm">
          {{ $t("geral.backtolist") }}
        </b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <sector-crud :model.sync="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-button class="mt-4" @click="save" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "SectorCreate",
  components: {
    SectorCrud: () => import("@/components_rms/System/Sector/Crud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  data() {
    return {
      alert: {
        success: "Setor registrado com sucesso",
        error: ""
      },
      submitted: false,
      model: {
        id: 0,
        displayName: "",
        managers: [],
        employees: []
      },
      modelstate: {}
    };
  },
  methods: {
    save() {
      this.modelstate = {};
      this.submitted = true;
      this.$apiScheduler
        .post("/sector/create/", this.model)
        .then(response => {
          this.cleanModel();
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch(error => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    cleanModel() {
      this.model = {
        id: 0,
        displayName: "",
        managers: [],
        employees: []
      };
    }
  }
};
</script>
